export default "__VITE_ASSET__h2W7wDpF__"